import { createSlice } from '@reduxjs/toolkit';
import { DashboardInitialState } from '../utils/Types';
import { LIST_VIEW_ITEM, SIDE_MENU_STATUS } from '../utils/Constant';

const initialState: DashboardInitialState = {
  selectedMenu: 'home',
  isOpenSideMenu: true,
  isMobile: false,
  listOrView: LIST_VIEW_ITEM.LIST_ITEMS,
};

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    updateSelectedMenu: (state, action) => {
      state.selectedMenu = action.payload;
    },
    updateSideMenuStatus: (state, action) => {
      switch (action?.payload) {
        case SIDE_MENU_STATUS.OPEN:
          state.isOpenSideMenu = true;
          break;
        case SIDE_MENU_STATUS.CLOSE:
          state.isOpenSideMenu = false;
          break;
        default:
          state.isOpenSideMenu = !state.isOpenSideMenu;
          break;
      }
    },
    updateDeviceStatus: (state, action) => {
      state.isMobile = action.payload.isMobile;
    },
    updateListViewItemsStatus: (state, action) => {
      state.listOrView = action.payload;
    },
  },
});
export const dashboardSelector = (state: any) => state.dashboard;
export const {
  updateSelectedMenu,
  updateSideMenuStatus,
  updateDeviceStatus,
  updateListViewItemsStatus,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
